/* ⚛ REACT */
import { useEffect, useRef, useState } from "react";

/* 📦 LIBS */
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

/* 🧩 COMPONENTS */
import { Button, Input, Label, Modal, CustomLoading, InputCheckbox, SaveIcon } from "../../../../Components";

/* 🔗 SERVICE */
import { PartsComandServices } from "../../../../Services/partscommandService";

/* 🧠 REDUX */
import { store } from "../../../../Redux/Store";
import { changeModal } from "../../../../Redux/Actions";

/* 🎨 STYLES */
import { Container, CountContainer, LineTitle, TitleText, LineList, ListText, PageTitle, ContainerList, 
    ContainerHead, ContainerRow, ButtonsContainer, ContainerColumn} from "./styles";

/* 🔧 UTILS */
import { isValidField } from "../../../../util/validate";

const ListPartsCommandsVariables = () => {
    const { t } = useTranslation();

    document.title = t("administrative.partCommands.variables");
    const Services = useRef(new PartsComandServices());
    const [partCommands, setPartCommands] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const NameField = useRef();
    const abbreviationField = useRef();
    const descriptionField = useRef();
    const unitField = useRef();
    const variablemqttField = useRef();
    const databasenamevariableField = useRef();
    const typeField = useRef();

    const Namevalue = useRef();
    const abbreviationvalue = useRef();
    const descriptionvalue = useRef();
    const unitvalue = useRef();
    const variablemqttvalue = useRef();
    const databasenamevariablevalue = useRef();
    const typevalue = useRef();
    const isSwitchvalue = useRef();
    const isAlarmvalue = useRef();
    const isReadOnlyvalue = useRef();


    useEffect(() => {
        async function getAllPartCommands(){
            let currentList = await Services.current.getPartCommandsVariables();
            setPartCommands(currentList)
            setIsLoading(false)
        }

        getAllPartCommands();
    }, [])

    // Salva as edições do usuário
    async function Save(){
        store.dispatch(changeModal(''))
        if(isValidField(Namevalue.current) && isValidField(abbreviationvalue.current) && 
            isValidField(unitvalue.current) && isValidField(variablemqttvalue.current) && 
            isValidField(databasenamevariablevalue.current) && isValidField(typevalue.current)){

            let form = new FormData();
            if(Namevalue.current){form.append('name', Namevalue.current)}
            if(abbreviationvalue.current){form.append('abbreviation', abbreviationvalue.current)}
            if(descriptionvalue.current){form.append('description', descriptionvalue.current)}
            if(unitvalue.current){form.append('unit', unitvalue.current)}
            if(variablemqttvalue.current){form.append('variablemqtt', variablemqttvalue.current)}
            if(databasenamevariablevalue.current){form.append('databasenamevariable', databasenamevariablevalue.current)}
            if(typevalue.current){form.append('type', typevalue.current)}
            form.append('isSwitch', isSwitchvalue.current ? 1 : 0)
            form.append('isAlarm', isAlarmvalue.current ? 1 : 0)
            form.append('isReadOnly', isReadOnlyvalue.current ? 1 : 0)

    
            await Services.current.SavePartCommandVariable(form)
        }else{
            toast(t("message.save"), {
                position: "top-center",
                type: 'info',
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: false,
                progress: undefined,
            });
        }
    }

    return(
        <>
            <Container>
                <PageTitle>
                    Variáveis de comandos
                </PageTitle>

                <ContainerHead>
                    <CountContainer>
                        {t("administrative.sub-items.list-total") + " " + partCommands.length + " Variáveis de comandos"  }
                    </CountContainer>

                    <Button onClick={()=>store.dispatch(changeModal('newPartCommand'))} width={'fit-content'} color={'green'} icon={''} text={"+  Nova variável de comando"}></Button>
                </ContainerHead>

                <ContainerList>
                    <LineTitle>
                        <TitleText>{t("header-table.name") }</TitleText>
                        <TitleText>{t("header-table.description") }</TitleText>
                        {/* <TitleText>{t("header-table.abbreviation") }</TitleText> */}
                    </LineTitle>

                    {isLoading?
                        <CustomLoading width={'150px'} height={'150px'}/>
                    :
                        partCommands?.map((item, index)=>(
                            <LineList key={index} href={`/PartCommandsVariables/${item.id}`}>
                                <ListText>{item.name}</ListText>
                                <ListText>{item.description}</ListText>
                                {/* <ListText>{item.abbreviation}</ListText> */}
                            </LineList>
                        ))
                    }
                </ContainerList>
            </Container>
            
            <Modal title={"Cadastrar variáveis"} name={'newPartCommand'} width={'70%'} height={'90%'} >
                
                <ContainerRow onSubmit={(e)=> e.preventDefault()}>
                    <ContainerColumn>
                        <Label text={t("inputs.name.label")} aling="flex-start"/>
                        <Input 
                            aling="flex-start"
                            id='name' 
                            name='name' 
                            type="text" 
                            placeholder= {t("inputs.name.placeholder")}
                            innerRef={NameField}
                            invalidMessage = {t("inputs.name.invalid-message")}
                            validationFunction = {(text) => isValidField(text)}
                            onchange={(text) => Namevalue.current = text}> 
                        </Input>

                        <Label text={t("inputs.description.label")} aling="flex-start"/>
                        <Input 
                            aling="flex-start"
                            id='description' 
                            name='description' 
                            type="text" 
                            placeholder= {t("inputs.description.placeholder")}
                            innerRef={descriptionField}
                            invalidMessage = {t("inputs.description.invalid-message")}
                            validationFunction = {(text) => isValidField(text)}
                            onchange={(text) => descriptionvalue.current = text}> 
                        </Input>

                        <Label text={t("inputs.abbreviation.label")} aling="flex-start"/>
                        <Input 
                            aling="flex-start"
                            id='abbreviation' 
                            name='abbreviation' 
                            type="text" 
                            placeholder= {t("inputs.abbreviation.placeholder")}
                            innerRef={abbreviationField}
                            invalidMessage = {t("inputs.abbreviation.invalid-message")}
                            validationFunction = {(text) => isValidField(text)}
                            onchange={(text) => abbreviationvalue.current = text}> 
                        </Input>

                        <Label text={t("inputs.type.label")} aling="flex-start"/>
                        <Input 
                            aling="flex-start"
                            id='type' 
                            name='type' 
                            type="text" 
                            placeholder= {t("inputs.type.placeholder")}
                            innerRef={typeField}
                            invalidMessage = {t("inputs.type.invalid-message")}
                            validationFunction = {(text) => isValidField(text)}
                            onchange={(text) => typevalue.current = text}> 
                        </Input>
                        
                    </ContainerColumn>

                    <ContainerColumn>
                    <Label text={t("inputs.unit.label")} aling="flex-start"/>
                        <Input 
                            aling="flex-start"
                            id='unit' 
                            name='unit' 
                            type="text" 
                            placeholder= {t("inputs.unit.placeholder")}
                            innerRef={unitField}
                            invalidMessage = {t("inputs.unit.invalid-message")}
                            validationFunction = {(text) => isValidField(text)}
                            onchange={(text) => unitvalue.current = text}> 
                        </Input>

                        <Label text={t("inputs.variablemqtt.label")} aling="flex-start"/>
                        <Input 
                            aling="flex-start"
                            id='variablemqtt' 
                            name='variablemqtt' 
                            type="text" 
                            placeholder= {t("inputs.variablemqtt.placeholder")}
                            innerRef={variablemqttField}
                            invalidMessage = {t("inputs.variablemqtt.invalid-message")}
                            validationFunction = {(text) => isValidField(text)}
                            onchange={(text) => variablemqttvalue.current = text}> 
                        </Input>

                        <Label text={t("inputs.databasenamevariable.label")} aling="flex-start"/>
                        <Input 
                            aling="flex-start"
                            id='databasenamevariable' 
                            name='databasenamevariable' 
                            type="text" 
                            placeholder= {t("inputs.databasenamevariable.placeholder")}
                            innerRef={databasenamevariableField}
                            invalidMessage = {t("inputs.databasenamevariable.invalid-message")}
                            validationFunction = {(text) => isValidField(text)}
                            onchange={(text) => databasenamevariablevalue.current = text}> 
                        </Input>

                        <InputCheckbox text={t("inputs.isSwitch.label")} onChange={(value)=> {isSwitchvalue.current = value; return true}}/>
                        <InputCheckbox text={t("inputs.isAlarm.label")} onChange={(value)=> {isAlarmvalue.current = value; return true}}/>
                        <InputCheckbox text={t("inputs.isReadOnly.label")} onChange={(value)=> {isReadOnlyvalue.current = value; return true}}/>
                    </ContainerColumn>
                </ContainerRow>

                
                <ButtonsContainer>
                    <Button text={t("buttons.save")} width={'150px'} icon={<SaveIcon/>} onClick={()=>Save()}/>
                    <Button text={t("buttons.cancel")} width={'150px'} color={'white-red'} onClick={()=>store.dispatch(changeModal(''))}/>
                </ButtonsContainer>
            </Modal>
        </>
    )
}

export default ListPartsCommandsVariables;